import { SelectionListServant, ISelectionList } from './../../global/servants/selection_list_servant';
import { IDatasource, IDatasourceConstructor } from 'utility-ng-kernel';
import { ChecklistItem } from './../builders/checklist_item_builder';
import { IChecklistFilterStrategy, IChecklistFilterAlgorithm } from '../strategies/checklist_filter_strategy';

interface IChecklistItemsDatasourceModel {
  checklistSelection: ISelectionList;
  checklistFilter: IChecklistFilterAlgorithm;
}

export interface IChecklistItemsDatasource extends IDatasource<ChecklistItem> {
  model: IChecklistItemsDatasourceModel;
}

angular
  .module('capability-ng-checklist')
  .factory('ngChecklistItemsDatasource', function(
    ngChecklistItemBuilder: typeof ChecklistItem,
    Datasource: IDatasourceConstructor<ChecklistItem>,
    ngSelectionListServant: SelectionListServant,
    ngChecklistFilterStrategy: IChecklistFilterStrategy
  ): IChecklistItemsDatasource {
    return new Datasource<ChecklistItem, IChecklistItemsDatasourceModel>({
      builderType: ngChecklistItemBuilder
    })
      .includeModel({
        checklistSelection: ngSelectionListServant.setMaximum(ngSelectionListServant.build(), 1),
        checklistFilter: ngChecklistFilterStrategy.normal
      })
      .configure({
        mergeStrategy: 'merge'
      });
  });



// WEBPACK FOOTER //
// ./app/lib/checklist/datasources/checklist_items_datasource.ts